import { render, staticRenderFns } from "./DiamondSpot.vue?vue&type=template&id=6c251df6&scoped=true"
import script from "./DiamondSpot.vue?vue&type=script&lang=js"
export * from "./DiamondSpot.vue?vue&type=script&lang=js"
import style0 from "./DiamondSpot.vue?vue&type=style&index=0&id=6c251df6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c251df6",
  null
  
)

export default component.exports